/**
 * Выборы визарда → вход создания персонажа.
 *
 * Слоты плана однородны: ключ, сколько выбрать, из чего. Вход же
 * создания однороден не полностью — вид, класс и предыстория стоят
 * в нём отдельными полями, потому что от них зависит сам план
 * (`creationPlan`, selection). Перевод одного в другое — здесь,
 * в единственном месте: интерфейсу знать имена этих трёх слотов
 * не нужно, он показывает то, что прислал сервер (D23).
 */
/** Обязательный слот остался пустым: персонажа из этого не собрать. */
export class CreationIncomplete extends Error {
    slot;
    constructor(slot) {
        super(`слот «${slot}» не заполнен: без него персонажа нет`);
        this.slot = slot;
        this.name = 'CreationIncomplete';
    }
}
/**
 * Слоты, которые в `CreationChoices` лежат полями, а не в `picks`.
 * Тот же список читает проверка выборов — второго списка нет.
 */
export const STRUCTURAL_SLOTS = ['class', 'background', 'species'];
export function isStructuralSlot(key) {
    return STRUCTURAL_SLOTS.includes(key);
}
function single(picks, slot) {
    return picks[slot]?.[0];
}
/**
 * Часть выборов, от которой зависит план: пока вид, класс
 * и предыстория не выбраны, их слотов в плане ещё нет.
 */
export function selectionFromPicks(picks) {
    const selection = {};
    for (const slot of STRUCTURAL_SLOTS) {
        const value = single(picks, slot);
        if (value !== undefined)
            selection[slot] = value;
    }
    return selection;
}
/**
 * Вход создания из выборов визарда. Порядок `picks` сохраняется таким,
 * каким его собрал интерфейс: сервер проверяет состав, а не порядок.
 */
export function choicesFromPicks({ name, picks, abilities, increase, }) {
    const structural = {
        class: '',
        background: '',
        species: '',
    };
    for (const slot of STRUCTURAL_SLOTS) {
        const value = single(picks, slot);
        if (value === undefined)
            throw new CreationIncomplete(slot);
        structural[slot] = value;
    }
    const rest = [];
    for (const [slot, values] of Object.entries(picks)) {
        if (isStructuralSlot(slot))
            continue;
        for (const value of values)
            rest.push({ slot, value });
    }
    return {
        name,
        species: structural.species,
        class: structural.class,
        background: structural.background,
        abilities,
        increase: increase.map((item) => ({ ...item })),
        picks: rest,
    };
}
//# sourceMappingURL=picks.js.map